import { motion } from "framer-motion";
import { springPresets } from "@/lib/motion";
import { ArrowLeft } from "lucide-react";
import { Link } from "react-router-dom";
import { CONTACT } from "@/data/index";

export default function AvisoLegal() {
  return (
    <div className="min-h-screen bg-background">
      {/* Header simple */}
      <header className="sticky top-0 z-50 bg-primary shadow-md">
        <div className="container mx-auto px-4 py-3 flex items-center gap-4">
          <Link to="/" className="flex items-center gap-2 text-primary-foreground/80 hover:text-accent transition-colors text-sm font-medium">
            <ArrowLeft size={18} /> Volver al inicio
          </Link>
          <img src="/images/logo.png" alt="Logo" className="h-10 w-auto object-contain ml-auto" />
        </div>
      </header>

      <div className="container mx-auto px-6 py-16 max-w-3xl">
        <motion.div initial={{ opacity: 0, y: 24 }} animate={{ opacity: 1, y: 0 }} transition={springPresets.gentle}>

          <div
            className="inline-block px-4 py-1.5 rounded-full text-xs font-semibold uppercase tracking-widest mb-6"
            style={{ background: "rgba(41,95,90,0.1)", color: "#295F5A", border: "1px solid #295F5A" }}
          >
            Información Legal
          </div>

          <h1 className="text-4xl font-extrabold mb-2" style={{ color: "#295F5A" }}>Aviso Legal</h1>
          <p className="text-muted-foreground text-sm mb-10">Última actualización: enero de 2025</p>

          <div className="prose prose-sm max-w-none space-y-8 text-foreground/80 leading-relaxed">

            <section>
              <h2 className="text-xl font-bold mb-3" style={{ color: "#295F5A" }}>1. Identificación del titular</h2>
              <p>
                En cumplimiento del artículo 10 de la Ley 34/2002, de 11 de julio, de Servicios de la Sociedad de la Información y del Comercio Electrónico (LSSI-CE), se informa al usuario de los datos identificativos del titular del presente sitio web:
              </p>
              <ul className="mt-3 space-y-1 list-none pl-0">
                <li><strong>Nombre / Razón social:</strong> {CONTACT.name}</li>
                <li><strong>NIF:</strong> 74739946C</li>
                <li><strong>Domicilio:</strong> {CONTACT.address}</li>
                <li><strong>Teléfono:</strong> {CONTACT.phone}</li>
                <li><strong>Correo electrónico:</strong> info@{CONTACT.web}</li>
                <li><strong>Sitio web:</strong> {CONTACT.web}</li>
              </ul>
            </section>

            <div className="h-px" style={{ background: "rgba(41,95,90,0.12)" }} />

            <section>
              <h2 className="text-xl font-bold mb-3" style={{ color: "#295F5A" }}>2. Objeto y ámbito de aplicación</h2>
              <p>
                El presente Aviso Legal regula el acceso y utilización del sitio web <strong>{CONTACT.web}</strong>, titularidad de Oscar Alaminos Serrano (en adelante, "el Titular"). El acceso al sitio web implica la aceptación plena y sin reservas de las presentes condiciones de uso.
              </p>
            </section>

            <div className="h-px" style={{ background: "rgba(41,95,90,0.12)" }} />

            <section>
              <h2 className="text-xl font-bold mb-3" style={{ color: "#295F5A" }}>3. Propiedad intelectual e industrial</h2>
              <p>
                Todos los contenidos del sitio web —textos, imágenes, logotipos, marcas, gráficos, archivos de audio y de vídeo, así como el diseño y código fuente— son propiedad del Titular o de sus proveedores, y están protegidos por la legislación vigente en materia de propiedad intelectual e industrial.
              </p>
              <p className="mt-3">
                Queda expresamente prohibida la reproducción, distribución, transformación o comunicación pública de cualquier contenido sin autorización escrita previa del Titular.
              </p>
            </section>

            <div className="h-px" style={{ background: "rgba(41,95,90,0.12)" }} />

            <section>
              <h2 className="text-xl font-bold mb-3" style={{ color: "#295F5A" }}>4. Exclusión de responsabilidad</h2>
              <p>
                El Titular no se responsabiliza de los daños y perjuicios de cualquier naturaleza que pudieran derivarse del uso indebido del presente sitio web, ni de los contenidos de sitios web de terceros accesibles mediante enlaces externos incluidos en el mismo.
              </p>
              <p className="mt-3">
                El Titular se reserva el derecho a modificar, suspender o cancelar el acceso al sitio web sin previo aviso, así como a actualizar el contenido en cualquier momento.
              </p>
            </section>

            <div className="h-px" style={{ background: "rgba(41,95,90,0.12)" }} />

            <section>
              <h2 className="text-xl font-bold mb-3" style={{ color: "#295F5A" }}>5. Protección de datos</h2>
              <p>
                Los datos personales facilitados a través del formulario de contacto serán tratados por Oscar Alaminos Serrano con la única finalidad de gestionar las consultas y presupuestos solicitados. Los datos no serán cedidos a terceros sin consentimiento expreso del usuario.
              </p>
              <p className="mt-3">
                El usuario podrá ejercer sus derechos de acceso, rectificación, supresión, limitación y portabilidad enviando un escrito al domicilio indicado en el apartado 1 o al correo electrónico info@{CONTACT.web}.
              </p>
            </section>

            <div className="h-px" style={{ background: "rgba(41,95,90,0.12)" }} />

            <section>
              <h2 className="text-xl font-bold mb-3" style={{ color: "#295F5A" }}>6. Legislación aplicable y jurisdicción</h2>
              <p>
                Las presentes condiciones se rigen por la legislación española. Para la resolución de cualquier controversia derivada del acceso o uso del sitio web, las partes se someten a los Juzgados y Tribunales de Granada, con renuncia expresa a cualquier otro fuero que pudiera corresponderles.
              </p>
            </section>

          </div>
        </motion.div>
      </div>

      <footer className="py-6 text-center text-xs mt-10" style={{ background: "#1e4a46", color: "rgba(255,255,255,0.4)" }}>
        <Link to="/" className="hover:text-accent transition-colors underline mr-4">Inicio</Link>
        <Link to="/politica-cookies" className="hover:text-accent transition-colors underline">Política de Cookies</Link>
        <p className="mt-2">© {new Date().getFullYear()} {CONTACT.name}</p>
      </footer>
    </div>
  );
}
